/**
 * Resolves parent + linked sibling order ids for multi-order save flows.
 * @module resolveLinkedOrderUpdateOrderIds
 */

/**
 * Builds the unique order ids that should receive the same save payload.
 *
 * @param parentOrderId - Current order being acted on
 * @param selectedOrderIds - Linked sibling order ids checked in a modal
 * @returns Deduped order ids, always including the parent when non-empty
 */
export const resolveLinkedOrderUpdateOrderIds = (
  parentOrderId: string,
  selectedOrderIds?: string[],
): string[] => {
  const linkedOrderIds =
    selectedOrderIds && selectedOrderIds.length > 0
      ? selectedOrderIds.filter(
          (linkedOrderId) => linkedOrderId && linkedOrderId !== parentOrderId,
        )
      : [];

  return [...new Set([parentOrderId, ...linkedOrderIds].filter(Boolean))];
};
